
import type { SymbolMap } from "../baseplatform";

/** Parse a cc65/ca65 or VICE label file into a symbol map. */
export function parseSymbolFile(text: string): SymbolMap {
  const symbols: SymbolMap = {};
  for (const line of text.split(/\r?\n/)) {
    const m1 = line.match(/^\s*([A-Za-z_][\w]*)\s*=\s*\$?([0-9A-Fa-f]+)\s*;/);            // ca65/cc65 list
    const m2 = line.match(/^\s*(?:al|add_label)\s+([0-9A-Fa-f]+)\s+\.?([A-Za-z_][\w]*)/); // VICE
    if (m1) symbols[m1[1]] = parseInt(m1[2], 16);
    else if (m2) symbols[m2[2]] = parseInt(m2[1], 16);
  }
  return symbols;
}

/**
 * Look up a symbol the way a user types it: exactly, then with the leading
 * underscore C compilers add (`main` finds `_main`), then without a leading
 * '.' (VICE labels).
 */
export function lookupSymbol(symbols: SymbolMap | null | undefined, name: string): number | undefined {
  const key = resolveSymbolName(symbols, name);
  return key == null ? undefined : symbols[key];
}

/** The key of `symbols` that `lookupSymbol` finds for `name`, if any. */
export function resolveSymbolName(symbols: SymbolMap | null | undefined, name: string): string | undefined {
  if (!symbols) return undefined;
  if (name in symbols) return name;
  if ('_' + name in symbols) return '_' + name;
  const bare = name.replace(/^\./, '');
  if (bare !== name && bare in symbols) return bare;
  return undefined;
}
